"use client";
import { Col, Row } from "@/utils/bootstrap";
import ContactUsForm from "./ContactUsForm";
import { useIsMobile } from "@/hooks/useIsMobile";
import CustomersServiceCarousel from "./customer-service/CustomersServiceCarousel";
import ContactUsSocial from "./ContactUsSocial";
import ContactUsEmail from "./contact-us-email/ContactUsEmail";
import ContactUsAddress from "./contact-us-address/ContactUsAddress";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";

const ContactUsBlackBox: React.FC = ({}) => {
  const mobile = useIsMobile();
  const getCompany = useGetCompanyQuery();
  const contacts = getCompany?.data?.result?.contacts;
  const mClass = mobile ? "-mobile" : "";
  if (!contacts) return null;
  return (
    <Row className={`m-0 contact-us${mClass}`} style={{ gap: 32 }}>
      <Col className="p-0" xs={{ order: mobile ? 1 : 2 }} lg={6}>
        <ContactUsForm />
      </Col>
      <Col
        lg={{ span: true }}
        xs={{ order: mobile ? 2 : 1 }}
        className="p-0 d-flex flex-column"
        style={{ gap: 24 }}
      >
        {contacts?.service_desk?.length > 0 ? (
          <CustomersServiceCarousel service_desk={contacts.service_desk} />
        ) : (
          <></>
        )}
        {!!contacts?.social_media && contacts?.social_media?.length > 0 && (
          <ContactUsSocial social_media={contacts?.social_media} />
        )}
        {!!contacts?.email && <ContactUsEmail email={contacts?.email} />}
        {!!contacts?.address && (
          <ContactUsAddress address={contacts?.address} />
        )}
      </Col>
    </Row>
  );
};

export default ContactUsBlackBox;
